import * as consts from '../constants';
import initialState from './initialState';

export default function tariffReducer(state = initialState.tariffState, action) {
    switch (action.type) {
        case consts.ACTONS.LOAD_TARIFFS_SUCCESS:
            return action.pagingModel;
        case consts.ACTONS.LOAD_TARIFFS_FAILED:
            return initialState.tariffState;
        default:
            return state;
    }
}